import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import {DeviceSettingList} from '../device-mgt.model';

export enum DeviceSettingListActionTypes {
  GetDeviceSettingLists = '[DeviceSettingList] Get DeviceSettingLists',
  LoadDeviceSettingLists = '[DeviceSettingList] Load DeviceSettingLists',
  AddDeviceSettingList = '[DeviceSettingList] Add DeviceSettingList',
  UpsertDeviceSettingList = '[DeviceSettingList] Upsert DeviceSettingList',
  AddDeviceSettingLists = '[DeviceSettingList] Add DeviceSettingLists',
  UpsertDeviceSettingLists = '[DeviceSettingList] Upsert DeviceSettingLists',
  UpdateDeviceSettingList = '[DeviceSettingList] Update DeviceSettingList',
  UpdateDeviceSettingLists = '[DeviceSettingList] Update DeviceSettingLists',
  GetDeleteDeviceSettingList = '[DeviceSettingList] Get Delete DeviceSettingLists',
  DeleteDeviceSettingList = '[DeviceSettingList] Delete DeviceSettingList',
  DeleteDeviceSettingLists = '[DeviceSettingList] Delete DeviceSettingLists',
  ClearDeviceSettingLists = '[DeviceSettingList] Clear DeviceSettingLists',
  GetDeviceSettingListsFail = '[DeviceSettingList] Get DeviceSettingLists Fail'
}

export class GetDeviceSettingLists implements Action {
  readonly type = DeviceSettingListActionTypes.GetDeviceSettingLists;
  constructor(public payload: any = null) {}
}

export class LoadDeviceSettingLists implements Action {
  readonly type = DeviceSettingListActionTypes.LoadDeviceSettingLists;

  constructor(public payload: DeviceSettingList[]) {}
}

export class AddDeviceSettingList implements Action {
  readonly type = DeviceSettingListActionTypes.AddDeviceSettingList;

  constructor(public payload: { deviceSettingList: DeviceSettingList }) {}
}

export class UpsertDeviceSettingList implements Action {
  readonly type = DeviceSettingListActionTypes.UpsertDeviceSettingList;

  constructor(public payload: { deviceSettingList: DeviceSettingList }) {}
}

export class AddDeviceSettingLists implements Action {
  readonly type = DeviceSettingListActionTypes.AddDeviceSettingLists;

  constructor(public payload: { deviceSettingLists: DeviceSettingList[] }) {}
}

export class UpsertDeviceSettingLists implements Action {
  readonly type = DeviceSettingListActionTypes.UpsertDeviceSettingLists;

  constructor(public payload: { deviceSettingLists: DeviceSettingList[] }) {}
}

export class UpdateDeviceSettingList implements Action {
  readonly type = DeviceSettingListActionTypes.UpdateDeviceSettingList;

  constructor(public payload: { deviceSettingList: Update<DeviceSettingList> }) {}
}

export class UpdateDeviceSettingLists implements Action {
  readonly type = DeviceSettingListActionTypes.UpdateDeviceSettingLists;

  constructor(public payload: { deviceSettingLists: Update<DeviceSettingList>[] }) {}
}

export class GetDeleteDeviceSettingList implements Action {
  readonly type = DeviceSettingListActionTypes.GetDeleteDeviceSettingList;
  constructor(public payload: { dcode: number}) {}
}

export class DeleteDeviceSettingList implements Action {
  readonly type = DeviceSettingListActionTypes.DeleteDeviceSettingList;

  constructor(public payload: { id: number }) {}
}

export class DeleteDeviceSettingLists implements Action {
  readonly type = DeviceSettingListActionTypes.DeleteDeviceSettingLists;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearDeviceSettingLists implements Action {
  readonly type = DeviceSettingListActionTypes.ClearDeviceSettingLists;
}

export class GetDeviceSettingListsFail implements Action {
  readonly type = DeviceSettingListActionTypes.GetDeviceSettingListsFail;
}

export type DeviceSettingListActions =
  GetDeviceSettingLists
 | LoadDeviceSettingLists
 | AddDeviceSettingList
 | UpsertDeviceSettingList
 | AddDeviceSettingLists
 | UpsertDeviceSettingLists
 | UpdateDeviceSettingList
 | UpdateDeviceSettingLists
 | GetDeleteDeviceSettingList
 | DeleteDeviceSettingList
 | DeleteDeviceSettingLists
 | ClearDeviceSettingLists
 | GetDeviceSettingListsFail;
